/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sheet_DescriptionInputs */

const en_us2_offline_sheet_description = /** @type {(inputs: Offline_Sheet_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The server refused these entries. Nothing is lost until you decide: try again, or discard.`)
};

const pt_br2_offline_sheet_description = /** @type {(inputs: Offline_Sheet_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O servidor recusou estes registros. Nada se perde até você decidir: tente de novo ou descarte.`)
};

const es_419_offline_sheet_description = /** @type {(inputs: Offline_Sheet_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El servidor rechazó estos registros. No se pierde nada hasta que decidas: reintentar o descartar.`)
};

const pt_pt2_offline_sheet_description = /** @type {(inputs: Offline_Sheet_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O servidor recusou estes registos. Nada se perde até decidires: tenta outra vez ou descarta.`)
};

const fr_fr2_offline_sheet_description = /** @type {(inputs: Offline_Sheet_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le serveur a refusé ces entrées. Rien n'est perdu tant que tu n'as pas décidé : réessayer ou supprimer.`)
};

const de_de2_offline_sheet_description = /** @type {(inputs: Offline_Sheet_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Server hat diese Einträge abgelehnt. Nichts geht verloren, bis du entscheidest: erneut versuchen oder verwerfen.`)
};

const it_it2_offline_sheet_description = /** @type {(inputs: Offline_Sheet_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il server ha rifiutato queste voci. Non si perde nulla finché non decidi: riprova o scarta.`)
};

/**
* | output |
* | --- |
* | "The server refused these entries. Nothing is lost until you decide: try again, or discard." |
*
* @param {Offline_Sheet_DescriptionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_sheet_description = /** @type {((inputs?: Offline_Sheet_DescriptionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sheet_DescriptionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_sheet_description(inputs)
	if (locale === "es-419") return es_419_offline_sheet_description(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_sheet_description(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_sheet_description(inputs)
	if (locale === "de-DE") return de_de2_offline_sheet_description(inputs)
	if (locale === "it-IT") return it_it2_offline_sheet_description(inputs)
	return en_us2_offline_sheet_description(inputs)
});
export { offline_sheet_description as "offline.sheet_description" }